import { CSSProperties, ReactNode } from 'react'
import { motion, useReducedMotion } from 'framer-motion'

type RevealProps = {
  children: ReactNode
  /** Extra delay in seconds — use index * 0.12 for card-grid staggers. */
  delay?: number
  /** Initial vertical offset (px). */
  y?: number
  /** Adds a slight scale-up + overshoot, like the mockup's card staggers. */
  pop?: boolean
  className?: string
  style?: CSSProperties
  as?: 'div' | 'section' | 'li' | 'span'
  /** Re-animate every time it scrolls into view (default: once). */
  repeat?: boolean
}

// Scroll-reveal wrapper — the framer-motion port of the mockup's GSAP
// ScrollTrigger reveals: elements rise, fade and (optionally) overshoot into
// place the first time they enter the viewport.
const Reveal = ({
  children,
  delay = 0,
  y = 46,
  pop = false,
  className,
  style,
  as = 'div',
  repeat = false,
}: RevealProps) => {
  const reduce = useReducedMotion()
  const Tag = (motion as any)[as] || motion.div

  if (reduce) {
    const Plain = as
    return (
      <Plain className={className} style={style}>
        {children}
      </Plain>
    )
  }

  return (
    <Tag
      className={className}
      style={style}
      initial={{ opacity: 0, y, scale: pop ? 0.94 : 1 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: !repeat, margin: '-12% 0px' }}
      transition={
        pop
          ? { duration: 0.7, delay, type: 'spring', stiffness: 220, damping: 18 }
          : { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }
      }
    >
      {children}
    </Tag>
  )
}

export default Reveal
